export const environment = {
    name: 'dev',
    baseApi: 'https://mmm-api-dev.econcloud.net',
    cdnUrl: 'https://mmm-assets.econcloud.net/dev',
    apiKey: 'e0e1a457-709f-42f1-81b1-9e29ea83e5a0',
};
